import React, {useContext} from 'react';
import PropTypes from 'prop-types';

//Context
import AppDataContext from '../../context/AppDataContext';

const TourGalleryPreview = ({artId, galleryId, imageUrl, imageAlt, numArt, onGalleryClick}) => {
  const {getLocalizedString} = useContext(AppDataContext);

  const setGallery = () => {
    onGalleryClick(artId, galleryId);
  };

  return(
    <div className='tour-gallery-preview' onClick={setGallery}>
      <div className='gallery-preview-image-container'>
        <img src={imageUrl} alt={imageAlt} />  
      </div>
      <div className="gallery-cta">
        <div className='link-container'>
          <span>{getLocalizedString('gallery_preview_open')}</span>
          <span className='chevron'></span>
        </div>
        <p className="images-counter">{numArt + ' ' + ((numArt <= 1) ? getLocalizedString('label_image') : getLocalizedString('label_images'))}</p>
      </div>
    </div>
  );
};

TourGalleryPreview.propTypes = {
  artId: PropTypes.string.isRequired,
  galleryId: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  numArt: PropTypes.number.isRequired,
  onGalleryClick: PropTypes.func
};

export default TourGalleryPreview;